import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';

class WizardSteps implements ng.IController {
    static $inject = [ '$translate', '$uibModal'];

    onAssign: () => any;
    onDiscard: () => any;
    step: number;

    constructor(
        protected $translate: angular.translate.ITranslateService,
        private $uibModal: ng.ui.bootstrap.IModalService,
    ) {
    }

    $onInit = () => {
        this.step = 1;
    }

    nextStep = () => {
        if (this.step !== 3) {
            this.step ++;
        } else {
            this.onAssign();
        }
    }

    backStep = () => this.step--;

    discard = async () => {
        let operationResult: any = await this.$uibModal.open({
            component: 'wizardDiscardPopup',
            resolve: {
                options: angular.noop
            },
            size: 'sm',
            backdrop: 'static',
        }).result;

        if (operationResult === 'ok') {
            this.onDiscard();
        }
    }

}

angular.module('naut').component('wizardSteps', {
    template: require('./wizard-steps.component.html'),
    controller: WizardSteps,
    controllerAs: 'ctrl',
    bindings: {
        step: '=',
        onAssign: '&',
        onDiscard: '&',
        nextButtonDisabled: '<'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/nfc-stickers/wizard/wizard-steps/wizard-steps.component.ts